import { getAxios } from '../../lib/projectAxios'
import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'

const axios = getAxios()
let cache = null
const fetchEnvParams = async (force = false) => {
  if (cache && !force) {
    return cache
  } else {
    try {
      const { status, data } = await axios.get('/envParams/get?t=' + new Date().getTime())
      if (status === 200 && data && data.status) {
        return (cache = data.data)
      }
    } catch (error) {
      console.error(error.stack)
    }
  }
}

export const getEnvParameters =
  (isForce = false) =>
  async (dispatch, getState) => {
    try {
      const data = await fetchEnvParams(isForce)
      let state = getState()
      const envList = _.map(data, (val) => ({
        name: val.name,
        isPublic: val.isPublic ?? false,
        type: val.type === 'static' ? 'static' : _.get(val, ['meta', 'type']),
      }))
      state = state.setIn(['envParams'], fromJS(envList))
      dispatch({
        type: actionTypes.SET_STORE,
        payload: {
          store: state,
        },
      })
    } catch (err) {
      console.error(err.stack)
    }
  }

export const fetchEnvParameter = async (name) => {
  try {
    const { status, data } = await axios.post('/webprojects/fetchEnvParameter/' + name)
    if (status === 200 && data && data.status) {
      return data
    }
  } catch (error) {
    console.error(error.stack)
  }
  return {
    status: false,
  }
}
